import type { SalesRepSettings } from "@forgepoint/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { BusinessDaysNote } from "./BusinessDaysNote";
import { DayListSettingField } from "./DayListSettingField";
import { NumberSettingField } from "./NumberSettingField";

interface SalesRepSettingsFormProps {
  value: SalesRepSettings;
  onChange: (value: SalesRepSettings) => void;
}

/** Settings form for the Sales Rep "My Deals" template. */
export function SalesRepSettingsForm({
  value,
  onChange,
}: SalesRepSettingsFormProps) {
  return (
    <div className="space-y-5">
      <BusinessDaysNote />
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-1">
          <Label className="text-sm">Customer follow-ups</Label>
          <p className="text-xs text-muted-foreground">
            Reminds the rep to chase quotes they have sent.
          </p>
        </div>
        <Switch
          checked={value.followUpsEnabled}
          onCheckedChange={(followUpsEnabled) =>
            onChange({ ...value, followUpsEnabled })
          }
          aria-label="Customer follow-ups enabled"
        />
      </div>
      {value.followUpsEnabled && (
        <DayListSettingField
          label="Follow-up cadence (business days after sending)"
          description="The rep is reminded this many business days after a quote goes out. Separate from the agent's follow-up intervals, which decide whether the agent chases the customer."
          value={value.followUpDays}
          onChange={(followUpDays) => onChange({ ...value, followUpDays })}
        />
      )}
      <NumberSettingField
        label="In-flight staleness (business days)"
        description="In-flight quotes older than this appear with what blocks them."
        value={value.inFlightStalenessDays}
        onChange={(inFlightStalenessDays) =>
          onChange({ ...value, inFlightStalenessDays })
        }
      />
    </div>
  );
}
